export enum VorgangLinkRel {
	SELF = 'self',
	VERFUEGUNGEN = 'verfuegungen',
	VERFAHREN = 'verfahren',
	RECHTSPFLEGER = 'rechtspfleger',
	ASSIGN_TO_RECHTSPFLEGE = 'assignToRechtspflege',
	OFFENE_VERFUEGUNG = 'offeneVerfuegung',
	UPDATE_NOTIZ = 'updateNotiz',
	MARK_AS_RECHTSPFLEGE = 'markAsRechtspflege',
	MARK_AS_RUECKLAUF = 'markAsRuecklauf',
	MARK_AS_WIEDERVORLAGE = 'markAsWiedervorlage',
	MARK_AS_ABGESCHLOSSEN = 'markAsAbgeschlossen',
	PROPOSE_WIEDERVORLAGEDATUM = 'proposeWiedervorlageDatum',
	DELETE = 'delete',
}

export enum VorgangListLinkRel {
	VORGANG_LIST = 'vorgangList',
}
